var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvelta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 156.66 35",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.52 8.1c-.22-.9-1.76-3.04-4.39-3.04S9.12 7.09 9.12 8.59s.56 2.92 6.11 6.41c8.25 4.72 5.47 15.15-2.51 15-2.25 0-5.92-1.42-7.65-5.66H6.2c0 .49 2.36 4.54 6.37 4.61 5.32.19 7.27-6.3 2.89-10.24-3.26-2.96-7.01-3.9-8.25-7.46-1.2-3.41 1.61-6.97 5.1-7.24 2.21-.15 4.61.75 5.62 2.96l.04 1.12h-.45zM31.77 8.01h2.35c2.47 6.34 4.92 12.69 7.39 19.03l7.77-19.03h.98L41.28 30h-.98c-2.85-7.33-5.68-14.66-8.53-21.99zM62.89 7.95h11.83v.89h-9.64v9.68h7.11v.89h-7.11v9.68h9.64v.89H62.89V7.95zM91.54 29.08h9.64v.89H89.35V7.95h2.19v21.13zM125.64 8.01v.89h-7.58V30h-2.19V8.9h-7.58v-.89h17.35zM150.93 29.94h-2.35c-2.47-6.34-4.95-12.69-7.39-19.03l-7.8 19.03h-.95l8.98-21.99h.98c2.82 7.33 5.67 14.66 8.53 21.99z",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvelta);
export default __webpack_public_path__ + "static/media/svelta.a6a24a0c103246221ab7e6f0394747b8.svg";
export { ForwardRef as ReactComponent };